module.exports = __webpack_public_path__ + "img/logo-dark.897ce483.svg";